// app/shared/hooks/useClientReady.ts
"use client";

import { useSyncExternalStore } from "react";

let clientReady = false;
const listeners = new Set<() => void>();

function subscribe(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  if (!clientReady) {
    clientReady = true;
    listeners.forEach((listener) => listener());
  }
  return () => {
    listeners.delete(onStoreChange);
  };
}

function getSnapshot(): boolean {
  return clientReady;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useClientReady(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
